import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { RegexEnum } from "../../../../../views/regex.enum";
import { DisabilityCatService } from "../../services/disabilitycat.service";

@Component({
  templateUrl: "./disabilitycat.component.html"
})
export class DisabilityCategoryComponent implements OnInit {
  public disabilityCat: any;
  public successMsg: string = "";
  public display = "none";
  public popUpType: string;
  public displayOrderErr: string = "";
  public categoryNmErr: string = "";
  public categoryDsErr: string = "";
  public categoryTypeErr: string = "";
  public informationErr: string = "";
  public statusErr: string = "";
  public displayOrderNumber: number;
  public statusCode: any = [];
  public categoryType: any = [];
  public category: any = {};

  constructor(private disabilityCatService: DisabilityCatService) { }

  ngOnInit() {
    this.statusCode = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" }
    ];

    this.categoryType = [
      { id: "A", catType: "Accommodation" },
      { id: "E", catType: "Support" }
    ];

    Observable.forkJoin(
      this.disabilityCatService.getDisabilityCategories()
    ).subscribe(([resp]) => {
      this.disabilityCat = resp.body;
    });
  }

  openPopUp(item: any, type: string) {
    this.popUpType = type;
    if (this.popUpType === "Edit") {
      console.log("edit content: " + item.DISABILITY_CATEGORY_NM);
      this.category.STATUS_CD = item.STATUS_CD;
      this.category.DISABILITY_CATEGORY_ID = item.DISABILITY_CATEGORY_ID;
      this.category.DISABILITY_CATEGORY_NM = item.DISABILITY_CATEGORY_NM;
      this.category.DISABILITY_CATEGORY_DS = item.DISABILITY_CATEGORY_DS;
      this.category.DISPLAY_ORDER_NO = item.DISPLAY_ORDER_NO;
      this.category.INFORMATION_TX = item.INFORMATION_TX;
      this.displayOrderNumber = item.DISPLAY_ORDER_NO;
      this.category.DISABILITY_CATEGORY_TYPE = item.DISABILITY_CATEGORY_TYPE;
      this.category.STATUS_CD = item.STATUS_CD;
    } else {
      this.category.DISABILITY_CATEGORY_NM = "";
      this.category.DISABILITY_CATEGORY_DS = "";
      this.category.INFORMATION_TX = "";
      this.category.DISABILITY_CATEGORY_TYPE = "A";
      this.category.DISPLAY_ORDER_NO = null;
      this.category.STATUS_CD = "A";
    }

    this.display = "block";
  }

  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }

  addRow() {
    let addRow: boolean = false;
    addRow = this.validateAddForm();
    if (addRow) {
      this.disabilityCatService.addDisabilityCategory(this.category).subscribe(
        resp => {
          if (resp) {
            this.closeCategoryPopUp();
            this.ngOnInit();
            this.successMsg =
              "Disability Category has been added successfully.";
          }
        },
        err => {
          if (err.error.error.message.includes("DISABILITY_CATEGORY_NM")) {
            this.categoryNmErr = "Disability Category is not valid";
          } else if (
            err.error.error.message.includes("DISABILITY_CATEGORY_DS")
          ) {
            this.categoryDsErr = "Disability Category description is not valid";
          } else if (err.error.error.message.includes("INFORMATION_TX")) {
            this.informationErr = "Information Text not valid";
          } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order Number is not Valid";
          } else if (
            err.error.error.message.includes("DISABILITY_CATEGORY_TYPE")
          ) {
            this.categoryTypeErr = "Disability Category Type is not valid";
          }
        }
      );
    }
  }

  editRow() {
    let editRow: boolean = false;
    editRow = this.validateEditForm();
    if (editRow) {
      this.disabilityCatService.editDisabilityCategory(this.category).subscribe(
        response => {
          if (response) {
            console.log("edit saved");
            this.closeCategoryPopUp();
            this.ngOnInit();
            this.successMsg = "All your changes have been saved.";
          }
        },
        err => {
          if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
            this.displayOrderErr = "Display Order Number is not Valid";
          }
        }
      );
    }
  }

  validateAddForm() {
    const notEmptyOrOnlyWhiteSpace = new RegExp(
      RegexEnum.NOT_EMPTY_OR_WHITESPACE
    );

    if (notEmptyOrOnlyWhiteSpace.test(this.category.DISABILITY_CATEGORY_NM)) {
      const disabilityCatNmPattern = RegexEnum.ALPHANUM_SP_100_PATTERN;
      const regex = new RegExp(disabilityCatNmPattern);
      if (regex.test(this.category.DISABILITY_CATEGORY_NM)) {
        this.categoryNmErr = "";
      } else {
        this.categoryNmErr = "Disability Category is not valid";
      }
    } else {
      this.categoryNmErr = "Disability Category is required";
    }

    if (notEmptyOrOnlyWhiteSpace.test(this.category.DISABILITY_CATEGORY_DS)) {
      const disabilityCatDsPattern = RegexEnum.ALPHANUM_SP_100_PATTERN;
      const regex = new RegExp(disabilityCatDsPattern);
      if (regex.test(this.category.DISABILITY_CATEGORY_DS)) {
        this.categoryDsErr = "";
      } else {
        this.categoryDsErr = "Disability Category Description is not valid";
      }
    } else {
      this.categoryDsErr = "Disability Category Description is required";
    }

    if (this.category.INFORMATION_TX && notEmptyOrOnlyWhiteSpace.test(this.category.INFORMATION_TX)) {
      const informationTextPattern = RegexEnum.ALPHANUM_SP_4000_PATTERN;
      const regex = new RegExp(informationTextPattern);
      if (regex.test(this.category.INFORMATION_TX)) {
        this.informationErr = "";
      } else {
        this.informationErr = "Information Text is not valid";
      }
    } else {
      this.informationErr = "Information Text is required";
    }

    if (this.category.DISPLAY_ORDER_NO && this.disabilityCat.length > 0) {
      this.category.DISPLAY_ORDER_NO = Number(this.category.DISPLAY_ORDER_NO);

      this.displayOrderErr = "";
    } else {
      this.displayOrderErr = "Display Order No is required";
    }

    if (this.category.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }

    if (
      this.categoryNmErr ||
      this.categoryDsErr ||
      this.categoryTypeErr ||
      this.informationErr ||
      this.displayOrderErr ||
      this.statusErr
    ) {
      return false;
    } else {
      return true;
    }
  }

  validateEditForm() {
    const notEmptyOrOnlyWhiteSpace = new RegExp(
      RegexEnum.NOT_EMPTY_OR_WHITESPACE
    );

    if (!this.category.DISPLAY_ORDER_NO) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      this.displayOrderErr = "";
    }

    if (notEmptyOrOnlyWhiteSpace.test(this.category.DISABILITY_CATEGORY_DS)) {
      const disabilityCatDsPattern = RegexEnum.ALPHANUM_SP_100_PATTERN;
      const regex = new RegExp(disabilityCatDsPattern);
      if (regex.test(this.category.DISABILITY_CATEGORY_DS)) {
        this.categoryDsErr = "";
      } else {
        this.categoryDsErr = "Disability Category Description is not valid";
      }
    } else {
      this.categoryDsErr = "Disability Category Description is required";
    }

    if (this.category.INFORMATION_TX && notEmptyOrOnlyWhiteSpace.test(this.category.INFORMATION_TX)) {
      const informationTextPattern = RegexEnum.ALPHANUM_SP_4000_PATTERN;
      const regexTxt = new RegExp(informationTextPattern);
      if (regexTxt.test(this.category.INFORMATION_TX)) {
        this.informationErr = "";
      } else {
        this.informationErr = "Information Text is not valid";
      }
    } else {
      this.informationErr = "Information Text is required";
    }

    if (this.category.STATUS_CD) {
      this.statusErr = "";
    } else {
      this.statusErr = "Please Select a status";
    }
    if (
      this.categoryNmErr ||
      this.categoryDsErr ||
      this.categoryTypeErr ||
      this.informationErr ||
      this.displayOrderErr ||
      this.statusErr
    ) {
      return false;
    } else {
      return true;
    }
  }

  closeCategoryPopUp() {
    this.resetForm();
    this.display = "none";
  }

  resetForm() {
    this.categoryNmErr = "";
    this.categoryDsErr = "";
    this.informationErr = "";
    this.displayOrderErr = "";
    this.statusErr = "";
    this.successMsg = "";
  }

  codeDisplay(code: string) {
    switch (code) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
    }
  }
  typeDisplay(catType: string) {
    switch (catType) {
      case "A":
        return "Accommodation";
      case "E":
        return "Support";
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/disability-category/disabilitycat.component.ts